import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--form-button-toggle"
export default class extends Controller {
  static targets = ["input", "button"];
  static values = {
    enableCondition: { type: String, default: "all" }, // all or any
  };

  connect() {
    this._updateButtonState();
  }

  toggle(e) {
    e.preventDefault();
    this._updateButtonState();
  }

  _updateButtonState() {
    let isValid = false;
    if (this.enableConditionValue === "all") {
      isValid = this.inputTargets.every((input) => input.value !== "");
    } else if (this.enableConditionValue === "any") {
      isValid = this.inputTargets.some((input) => input.value !== "");
    }

    if (isValid) {
      this.buttonTarget.classList.remove("c-btn-disabled");
    } else {
      this.buttonTarget.classList.add("c-btn-disabled");
    }
  }
}
